export default "__VITE_ASSET__DFymq5QG__"